import React from 'react'
import CIcon from '@coreui/icons-react'

export default [
  {
    _tag: 'CSidebarNavItem',
    name: 'Genral Ledger',
    to: '/Ledger',
    fk_type:1,
    icon: <img src="../img/MydashB.png" width="20px" height="20px" ></img>
    ,
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Item Description',
    to: '/Item/New',
    fk_type:0,
    icon: <img src="../img/MydashB.png" width="20px" height="20px" ></img>
    ,
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Item List',
    to: '/Item/List',
    fk_type:0,
    icon: <img src="../img/MydashB.png" width="20px" height="20px" ></img>
    ,
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Sale Order',
    to: '/Sale/Order',
    fk_type:1,
    icon: <img src="../img/MydashB.png" width="20px" height="20px" ></img>
    ,
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
 
  {
    _tag: 'CSidebarNavItem',
    name: 'Order List',
    to: '/Sale/List',
    fk_type:1,
    icon: <img src="../img/MydashB.png" width="20px" height="20px" ></img>
    ,
    badge: {
      color: 'info',
      text: 'NEW',
    }
  },
 
  
]

